import { getKnowledgeQuestions } from '@/api/sameQuestion'
import { Toast } from '@/plugin/vant'

export function checkIsHasSameQuestion({ questionId, success }) {
  return getKnowledgeQuestions({
    questionId: questionId,
    start: 0,
    top: 1
  })
    .then((res) => {
      console.log(res)
      if (res.status === 200 && res.data.questions.length > 0) {
        success && success(res)
      } else {
        this.$trackevent({
          type: 'funcTracker',
          action: 'click',
          opt_label: `暂无题目-举一反三-all`
        })
        Toast('暂无题目，敬请期待')
      }
      return res
    })
    .catch((err) => {
      console.error(err)
      Toast('暂无题目')
    })
}
